import { render, staticRenderFns } from "./linkItem.vue?vue&type=template&id=f78ba4ce&"
import script from "./linkItem.vue?vue&type=script&lang=js&"
export * from "./linkItem.vue?vue&type=script&lang=js&"
import style0 from "./linkItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports